module.exports = __webpack_public_path__ + "img/car_00057.99c5cca6.jpg";